import { VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { MenuActionListProps } from "./types";
import { MenuActionItem } from "./components/MenuActionItem";

export const MenuActionsList = ({
  title,
  menuItems,
  width = "46%",
  titleStyles,
  gap = "$3"
}: MenuActionListProps) => {
  return (
    <VStack w="$full" alignItems="center">
      <VStack $base-w="$full" $md-w={width} gap={gap}>
        {title && (
          <Text fontWeight={400} mb="$1" {...titleStyles}>
            {title}
          </Text>
        )}
        {menuItems.map((menuItem, index) => (
          <MenuActionItem key={index.toString()} {...menuItem} />
        ))}
      </VStack>
    </VStack>
  );
};
